import { useMemo } from "react";
import QuoteReviewErrorsTable from "./quoteReviewErrorsTable";

const QuoteReviewErrorsForItems = ({
    quoteItems
}) => {

    const uniqueItemErrors = useMemo(() => {
        const allErrors = quoteItems.flatMap(item => item.validationErrors);

        // Deduplicate by the 'error' property only
        const errorMap = new Map();

        for (const err of allErrors) {
            if (!errorMap.has(err.error)) {
            errorMap.set(err.error, err);
            }
        }

        return Array.from(errorMap.values());
    }, [quoteItems]);


    const itemWarningsTableData = useMemo(() => {
        const tableData = [];

        uniqueItemErrors.forEach(error => {
            const itemsWithThisError = quoteItems.filter(item =>
                item.validationErrors.some(e => e.error === error.error)
            );

            tableData.push({           
                id: error.error,
                error: error.error,
                items: itemsWithThisError.map(item => {
                    const errorId = `${item.guid}_${error.id}`;

                    return ({
                        ...item,
                        id: errorId,
                        detail: <div style={{ flexDirection: "column" }}><div><strong>{item.quoteGroupDescription}: </strong></div><div><span>{item.internalName}</span></div></div>
                    });
                })
            });
        });

        return tableData;
    }, [uniqueItemErrors, quoteItems]);


    return (
        <QuoteReviewErrorsTable
            header="Item Errors"
            errors={itemWarningsTableData}
        />    
    );
}
export default QuoteReviewErrorsForItems;